import { TrelloReconnectButton } from './TrelloReconnectButton';
import { TrelloServiceComponent } from './TrelloServiceComponent';
export const TrelloReconnectionConfig = {
  reconnectButton: TrelloReconnectButton,
  serviceComponent: TrelloServiceComponent
};